import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "LanguageDropdown" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_AtSelectNative = _resolveComponent("AtSelectNative");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_AtSelectNative, {
            class: "LanguageDropdown-select text-gray-900 font-subtext-b",
            modelValue: _ctx.locale,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.locale) = $event)),
            "aria-label": _ctx.$t('login.footer.language_select'),
            options: _ctx.languagesList
        }, null, 8, ["modelValue", "aria-label", "options"])
    ]));
}
